import useSWR from "swr";
import { useSearchParams } from "react-router-dom";

import { useApiAccess } from "./useApiAccess";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { getCategoryBySlugs } from "../../Service/CategoryService";

export const useCategoryBySlugs = ( slugs = []) => {
    const hasAccess = useApiAccess();
    const [searchParams] = useSearchParams();
    const productParam = searchParams.get('product');

    const pathParams = {
        ...(productParam && { product: productParam }),
    };

    const categorySlugs = slugs.filter( slug => slug?.length > 0 );

    return useSWR(
        hasAccess && categorySlugs?.length > 0 ? `${apiRoutes.categoryBySlugs}${categorySlugs.join(',')}` : null,
        () => getCategoryBySlugs({ categorySlugs }, pathParams)
    );
}